import React, { useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

export type OfficeItem = {
    id: string;
    name: string;
    ceo: string;
    registrationNumber: string;
    phone: string;
    address: string;
};

type Props = {
    item: OfficeItem;
    className?: string;
};

const OfficeInfoCard: React.FC<Props> = ({ item, className }) => {
    return (
        <Card className={className} aria-label="선택된 중개사무소">
            <HeaderRow>
                <Title>선택된 중개사무소</Title>
            </HeaderRow>

            <Row>
                <Label>성함</Label>
                <Value>{item.ceo}</Value>
            </Row>
            <SoftLine />

            <Row>
                <Label>사무소명</Label>
                <Value>{item.name}</Value>
            </Row>
            <SoftLine />

            <Row>
                <Label>중개등록번호</Label>
                <Value>{item.registrationNumber}</Value>
            </Row>
            <SoftLine />

            <Row>
                <Label>전화번호</Label>
                <Value>{item.phone}</Value>
            </Row>
            <SoftLine />

            <Row>
                <Label>소재지</Label>
                <Value className="multiline">{item.address}</Value>
            </Row>
        </Card>
    );
};

export default OfficeInfoCard;

const Card = styled.section`
    margin-top: 12px;
    padding: 14px 12px;
    border-radius: 14px;
    background: #f6f6fa;
`;

const HeaderRow = styled.div`
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const Title = styled.h3`
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #0f1523;
`;

const EditButton = styled.button`
    padding: 6px 10px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 400;
    text-decoration: underline;
    color: #2a62ff;
    cursor: pointer;
`;

const Line = styled.hr`
    border: 0;
    height: 1px;
    background: #e6e8ec;
    margin: 12px 0;
`;

const SoftLine = styled(Line)`
    margin: 10px 0;
`;

const Row = styled.div`
    display: grid;
    grid-template-columns: 88px 1fr;
    column-gap: 12px;
    align-items: start;
`;

const Label = styled.div`
    color: #505050;
    font-size: 14px;
    font-weight: 400;
    line-height: 140%;
    justify-content: center;
`;

const Value = styled.div`
    color: #161a2a;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.6;
    &.multiline {
        white-space: pre-line;
    }
`;
